<template>
  <TwcButton :class="buttonClasses" class="touch-manipulation">
    <span :class="titleClasses">{{ title }}</span>
    <span class="text-xs text-gray-500 block">{{ description }}</span>
  </TwcButton>
</template>

<script setup lang="ts">
import { TwcButton } from 'transit-web-components'
import { computed } from 'vue'

const props = defineProps({
  selected: {
    type: Boolean,
    default: false
  },
  title: {
    type: String,
    required: true
  },
  description: {
    type: String,
    default: ''
  },
  small: {
    type: Boolean,
    default: false
  },
  light: {
    type: Boolean,
    default: false
  }
})

const buttonClasses = computed(() => {
  let baseClass = `text-left bg-white h-16 w-full hover:bg-color-white focus:ring-0 focus:ring-offset-0 border px-3`

  if (props.selected) {
    baseClass = `${baseClass} border-2 border-seastreak-action-blue`
  }

  if (props.small) {
    baseClass = `${baseClass} h-10 text-center`
  }

  if (props.light) {
    baseClass = `${baseClass} h-10 font-light`
  }
  return baseClass
})

const titleClasses = computed(() => {
  let baseClass = 'text-lg text-gray-900 leading-4 block'

  if (props.small) {
    baseClass = `${baseClass} text-sm`
  }

  return baseClass
})
</script>

<style scoped>
.touch-manipulation {
  touch-action: manipulation;
}
</style>
